<template>
  <tabela-padrao-prime-vue
    class="my-4"
    :colunas="tabela.colunas"
    :dados="tabela.dados"
    :mostrar-acoes="false"
    :sem-paginacao="true"
    :mostra-header="false"
    :mostrar-seletor="false"
  />
</template>
<script>
import helpers from '@common/utils/helpers';

export default {
  props: {
    form: {},
  },
  data() {
    return {
      tabela: {
        dados: [],
        colunas: [
          {
            value: 'dataAprovacao',
            text: this.$t('modulos.orcamentos.formulario.historico.data_hora'),
            sortable: true,
            formatter: (v) => {
              if (v) return helpers.formatarDataBr(v, true);
            },
          },
          {
            value: 'usuario.nome',
            text: this.$t('modulos.orcamentos.formulario.historico.nome_usuario'),
            sortable: true,
          },
          {
            value: 'tipo',
            text: this.$t('modulos.orcamentos.formulario.historico.acao'),
            sortable: true,
            formatter: (v) => {
              return helpers.AcaoOrcamentoEnum.find((el) => el.value === v)?.text;
            },
          },
          {
            value: 'observacao',
            text: this.$t('modulos.orcamentos.formulario.historico.observacao'),
            sortable: true,
          },
        ],
      },
    };
  },
  mounted() {
    this.listarDados();
  },
  methods: {
    listarDados: function () {
      this.tabela.dados = this.form.aprovacoes;
    }
  },
};
</script>
  